module.exports = __webpack_public_path__ + "img/btn-code-reg-bg-hover.a35bfc2c.png";